module.exports = __webpack_public_path__ + "static/media/SKInteracFR.a5f2b5ab.png";